import React, { useState } from 'react';
import { User, Shield, Briefcase, Handshake, ChevronDown } from 'lucide-react';
import RoleCard from './RoleCard';
import { rolesData } from '../data/mockData';

export const RoleDocumentation = () => {
  const [activeRole, setActiveRole] = useState('nasabah');

  const roleIcons = {
    nasabah: User,
    admin: Shield,
    petugas: Briefcase,
    rekanan: Handshake,
  };

  const roleTabs = [
    { id: 'nasabah', label: 'Nasabah', color: 'emerald' },
    { id: 'admin', label: 'Admin', color: 'blue' },
    { id: 'petugas', label: 'Petugas', color: 'purple' },
    { id: 'rekanan', label: 'Rekanan', color: 'orange' },
  ];

  return (
    <section id="roles" className="py-20 px-4 sm:px-6 lg:px-8 bg-white dark:bg-slate-900/50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold mb-6 bg-gradient-to-r from-slate-900 to-slate-700 dark:from-white dark:to-slate-300 bg-clip-text text-transparent">
            Dokumentasi Fitur Berdasarkan Role
          </h2>
          <p className="text-lg text-slate-600 dark:text-slate-400 max-w-3xl mx-auto">
            Setiap pengguna memiliki akses dan fitur yang disesuaikan dengan peran mereka dalam sistem
          </p>
        </div>

        {/* Role Tabs - Desktop */}
        <div className="hidden md:flex justify-center mb-12 space-x-4">
          {roleTabs.map((tab) => {
            const Icon = roleIcons[tab.id];
            return (
              <button
                key={tab.id}
                onClick={() => setActiveRole(tab.id)}
                className={`flex items-center space-x-3 px-6 py-4 rounded-xl font-semibold transition-all duration-300 ${
                  activeRole === tab.id
                    ? 'bg-gradient-to-r from-emerald-600 to-teal-600 text-white shadow-lg scale-105'
                    : 'bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700'
                }`}
              >
                <Icon className="h-5 w-5" />
                <span>{tab.label}</span>
              </button>
            );
          })}
        </div>

        {/* Role Tabs - Mobile Dropdown */}
        <div className="md:hidden mb-12">
          <div className="relative">
            <button
              onClick={() => {
                const dropdown = document.getElementById('mobile-role-dropdown');
                dropdown.classList.toggle('hidden');
              }}
              className="w-full flex items-center justify-between px-6 py-4 bg-gradient-to-r from-emerald-600 to-teal-600 text-white rounded-xl font-semibold shadow-lg"
            >
              <div className="flex items-center space-x-3">
                {React.createElement(roleIcons[activeRole], { className: 'h-5 w-5' })}
                <span>{roleTabs.find((t) => t.id === activeRole)?.label}</span>
              </div>
              <ChevronDown className="h-5 w-5" />
            </button>
            <div
              id="mobile-role-dropdown"
              className="hidden absolute top-full left-0 right-0 mt-2 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-200 dark:border-slate-700 overflow-hidden z-10"
            >
              {roleTabs.map((tab) => {
                const Icon = roleIcons[tab.id];
                return (
                  <button
                    key={tab.id}
                    onClick={() => {
                      setActiveRole(tab.id);
                      document.getElementById('mobile-role-dropdown').classList.add('hidden');
                    }}
                    className="w-full flex items-center space-x-3 px-6 py-4 text-left hover:bg-emerald-50 dark:hover:bg-slate-700 transition-colors"
                  >
                    <Icon className="h-5 w-5 text-slate-600 dark:text-slate-400" />
                    <span className="text-slate-700 dark:text-slate-300 font-medium">{tab.label}</span>
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        {/* Role Content */}
        <div className="transition-all duration-500">
          <RoleCard role={rolesData[activeRole]} icon={roleIcons[activeRole]} />
        </div>
      </div>
    </section>
  );
};

export default RoleDocumentation;